import { memo } from "react";
import { FilePreviewImagePreview } from "./FilePreviewImagePreview";
import { FilePreviewPdfPreview } from "./FilePreviewPdfPreview";
import { FilePreviewUnsupportedFormat } from "./FilePreviewUnsupportedFormat";
import { FilePreviewContentProps, UNSUPPORTED_FILE_TYPE } from "./types";
import { useFilePreviewType } from "./hooks";
import { getFilePreviewType } from "./utils/getFilePreviewType";

export const getDialogClassName = (
  fileUrl: string,
  fileName?: string,
  mimeType?: string,
): string => {
  const fileType = getFilePreviewType(fileUrl, fileName, mimeType);
  return fileType === "pdf"
    ? "file-preview-dialog-pdf"
    : "file-preview-dialog-image";
};

export const getDialogContainerClassName = (
  fileUrl: string,
  fileName?: string,
  mimeType?: string,
): string => {
  const fileType = getFilePreviewType(fileUrl, fileName, mimeType);
  return fileType === "pdf"
    ? "flex-1 min-h-0 overflow-hidden"
    : "overflow-auto flex items-center justify-center min-h-0";
};

export const getInlineClassName = (fullPage: boolean): string =>
  fullPage ? "w-full h-full" : "flex items-center justify-center w-full";

export const FilePreviewContent = memo(
  ({
    fileUrl,
    fileName,
    mimeType,
    maxWidth,
    maxHeight,
    isFullScreen = false,
    isScrollLayout = false,
  }: FilePreviewContentProps) => {
    const fileType = useFilePreviewType(fileUrl, fileName, mimeType);

    switch (fileType) {
      case "pdf":
        return (
          <FilePreviewPdfPreview
            src={fileUrl}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
            isFullScreen={isFullScreen}
            isScrollLayout={isScrollLayout}
          />
        );
      case "jpg":
      case "png":
        return (
          <FilePreviewImagePreview
            src={fileUrl}
            alt={fileName}
            maxWidth={maxWidth}
            maxHeight={maxHeight}
          />
        );
      case UNSUPPORTED_FILE_TYPE:
      default:
        return <FilePreviewUnsupportedFormat />;
    }
  },
);
